module.exports = __webpack_public_path__ + "static/media/step-ladders-large@3x.dd1e7303.png";